<template>
    <main>
        <div class="heroCont" v-if="data && data.page">
            <div class="infoBar">
                <WebsiteBreadcrumbs>
                    <span>publications</span>
                </WebsiteBreadcrumbs>
            </div>
            <h1 class="helvetica title1">{{ data.page?.title }}</h1>
            <div class="line"></div>
            <div class="body" v-if="data.page.introduction" v-html="data.page.introduction"></div>
        </div>
        <div class="books" v-if="data && data.books">
            <ItemBook v-for="book in data.books.data" :book="book" />
        </div>
        <WebsiteFooter v-if="data && data.page" />
    </main>
</template>

<script lang="ts" setup>
const { getBookshopPage } = usePublications();
const directusUrl = useDirectusUrl()
const { data } = useAsyncData(`publications-bookshop`, () => getBookshopPage());

useSeoMeta({
    title: () => `${data.value?.page?.title} | Publications | EIC Federation`,
    ogTitle: () => `${data.value?.page?.title} | Publications | EIC Federation`,
    twitterTitle: () => `${data.value?.page?.title} | Publications | EIC Federation`,

    description: () => data.value?.page?.summary,
    ogDescription: () => data.value?.page?.summary,
    twitterDescription: () => data.value?.page?.summary,

    ogImage: () => data.value?.page?.cover?.id ? directusUrl + '/assets/' + data.value?.page.cover.id : undefined,
})
</script>

<style lang="scss" scoped>
main {
    padding-top: var(--size-padding-header);

    .heroCont {
        margin: 0 var(--size-margin-page) var(--size-gutter-sections) var(--size-margin-page);
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0 var(--size-margin-page);

        .infoBar {
            margin-bottom: var(--size-gutter-default);
            color: var(--color-primary);

            .date {
                display: flex;
                gap: var(--size-gutter-default);
            }
        }

        h1 {
            grid-column: 1 / span 2;
            margin-bottom: var(--size-gutter-double);
        }

        .line {
            grid-column: 1 / span 2;
            height: var(--size-thickness);
            background-color: var(--color-primary);
        }

        .body {
            margin-top: var(--size-gutter-default);
            grid-column: 2;
            font-weight: bold;
        }
    }

    .books {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: var(--size-gutter-double) var(--size-margin-page);
        padding: 0 var(--size-margin-page);
    }
}


@media screen and (max-width: 1200px) {
    main {
        .heroCont {

            .body,
            .downloadsCont {
                grid-column: 1 / span 2;
            }
        }

        .books {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
    }
}

@media screen and (max-width: 768px) {
    main {
        .books {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }
}

@media screen and (max-width: 600px) {
    main {
        .books {
            grid-template-columns: 1fr;
            gap: var(--size-gutter-large) 0;
        }
    }
}
</style>